var React = require('react');
var Checkbox = require('./index.js');
var css = require('./module.scss');
var Row = require('../grid/row.js');
var Col = require('../grid/col.js');

/**
 * 使用方法：
 * <CheckBoxList
 *     options={ [
 *         { name: 'apple', checked: true, value: 1 },
 *         { name: 'banana', checked: false, value: 2 }
 *     ] }
 *     onChange={ this.checkboxChange }
 *     cols={6}
 * />
 *
 * onChange回调中返回参数：checked状态，e事件对象，i当前元素在list中的index
 */

let defaultKey = {
    title: 'name',
    value: 'value'
};

var List = React.createClass({
    inArray: function(val, arr) {
        for (var _val, i = 0, len = arr.length; i < len; i++) {
            if (val.toString() == arr[i].toString()) {
                return true;
            }

        }
        return false;
    },

    dataHandler: function(data, len) {
        let res = [];
        data.map((item, index) => {
            // item.index = index;
            if (index % len == 0) {
                res.push([item]);
            } else {
                res[res.length - 1].push(item);
            }
        });
        return res;
    },

    render: function() {
        let _this = this;
        let values = this.props.value || [];
        let len = this.props.cols || 8;
        let data = this.dataHandler(this.props.options, len);

        let keyMap = defaultKey;
        if (this.props.keyMap) {
            keyMap = this.props.keyMap;
        }

        return <div className={'fp-checkboxList' + (this.props.className ? ' ' + this.props.className : '')}>
            {
                data.map((row, index) => {
                    return <Row className="fp-checkboxList-row">
                        {
                            row.map((item, subIndex) => {
                                return <Col span={24 / len}>
                                    <Checkbox
                                        name={_this.props.name}
                                        value={item[keyMap.value]}
                                        listIndex={index * len + subIndex}
                                        onChange={_this.props.onChange}
                                        onFocus={_this.props.onFocus}
                                        onBlur={_this.props.onBlur}
                                        disabled={this.props.disabled ? true : item.disabled ? true : false}
                                        readonly={item.readonly}
                                        checked={item.checked}
                                        title={item[keyMap.title]}
                                    />
                                </Col>;
                            })
                        }
                    </Row>;
                })
            }
        </div>;
    }
});

module.exports = List;




// WEBPACK FOOTER //
// ./component/checkbox/list.js